$(document).ready(function () {
  if ($("#Form_ComplaintSubmissionForm").length > 0) {
    // if there is a form or a field validation error we need to show it
      if ($("#Form_ComplaintSubmissionForm_error").hasClass("validation") ||
        $("#Form_ComplaintSubmissionForm").find("span.message").hasClass("validation")) {

            // if there is an accordion we need to open it
        if ($(".contact-accordion").length > 0) {
          var closestToForm = $("#Form_ComplaintSubmissionForm")
            .closest(".contact-details")
            .siblings(".contact-title");
          closestToForm.next().slideDown();
          closestToForm.parent().toggleClass("open");
          closestToForm.find("span.arrow").addClass("open");
        }

        //after a period of time lets scroll to the form to show error
        setTimeout(function () {
          $(document).off("scroll");
          $("html, body")
            .stop()
            .animate(
              {
                scrollTop: $("#Form_ComplaintSubmissionForm").offset().top - 100,
              },
              500,
              "swing"
            );
        }, 500);
      }
  }

  if ($("#Form_StatusUpdateForm").length > 0) {
    // if there is a validation error we need to show it
    if ($("#Form_StatusUpdateForm_error").hasClass("validation")  ||
        $("#Form_StatusUpdateForm").find("span.message").hasClass("validation")) {

      $(document).off("scroll");
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $("#Form_StatusUpdateForm").offset().top - 150,
          },
          500,
          "swing"
        );
    }
  }
});
